import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY } from '../services/queryEndPoint';
import { Api } from '../services/interceptor';
import type { ITournamentsByLeagueResponse } from '../views/leaguesHome/types/home';
import TournamentsDetails from '../views/leaguesHome/tournaments/tournamentsDetails/TournamentsDetails';

const TournamentRouteHydrator: React.FC = () => {
  const { leagueId, tournamentId } = useParams<{
    leagueId: string;
    tournamentId: string;
  }>();

  // Synchronously sync sessionStorage during render so downstream children
  // (Matches, Gallery, etc.) that read from sessionStorage on mount pick up
  // the correct tournamentId on the very first render.
  if (
    typeof window !== 'undefined' &&
    tournamentId &&
    sessionStorage.getItem('tournamentId') !== tournamentId
  ) {
    sessionStorage.setItem('tournamentId', tournamentId);
    // Clear stale name so we don't show the previous tournament's name while fetching.
    sessionStorage.removeItem('tournamentName');
  }

  const { data: tournaments } = useQuery<ITournamentsByLeagueResponse>({
    queryKey: [QUERY_KEY.getTournamentsByLeagues, leagueId],
    enabled: !!leagueId,
    queryFn: async () =>
      (
        await Api.get<ITournamentsByLeagueResponse>(
          `${QUERY_KEY.getTournamentsByLeagues}/${leagueId}`,
        )
      ).data,
  });

  useEffect(() => {
    if (!tournamentId || !tournaments?.tournamentResponses) return;
    const match = tournaments.tournamentResponses.find(
      (t) => t.tournamentId === tournamentId,
    );
    if (match) {
      sessionStorage.setItem('tournamentName', match.tournamentName ?? '');
      window.dispatchEvent(new Event('tournamentTabChanged'));
    }
  }, [tournamentId, tournaments]);

  return <TournamentsDetails />;
};

export default TournamentRouteHydrator;
